<template>
        <main class="bottom-bg">
            <div class="video-wrapper">
                <video width="100%" height="100%" id="main-video" autoplay muted playsinline>
                    <source src="~@/assets/video/P_01.webm" type="video/webm" />
                    <source src="~@/assets/video/P_01.mp4" type="video/mp4" />
                </video>
            </div>
            <h1><span class="acier">404</span> Strona nie została znaleziona</h1>
            <a href="javascript:void(0)" class="arrow-link more-results go-home" title="">
                <span>IDŹ DO STRONY GŁÓWNEJ</span>
                <svg class="arrow-wrapper" viewBox="0 0 113.7 90">
                    <path class="arrow" d="M113.7,45 98.7,29.9 68.8,0 58.2,10.7 77.4,29.9 77.4,29.9 0,29.9 0,45 Z"/>
                    <path class="arrow arrow2" d="M0,45 0,60.1 77.4,60.1 77.4,60.1 58.2,79.3 68.8,90 98.7,60.1 113.7,45 Z"/>
                </svg>
            </a>
        </main>
</template>

<script>
export default {
  name: 'NotFoundContent',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  beforeCreate() {
      document.body.classList.add('page-404')
  },
  beforeDestroy() {
      document.body.classList.remove('page-404')
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/NotFound/NotFoundContent.vue